import ReactECharts from "echarts-for-react";
import { toast } from "jquery";
import { useEffect, useRef, useState } from "react";
import { RefreshCcw } from "react-feather";
import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import { useSelector } from "react-redux";
import "react-resizable/css/styles.css";
import {
  getLiveRequestSummaryData,
  getRequestStatusSummary,
  getShipperWiseJobs,
  getVehicleTypeData,
} from "../api/dashboardApi";
import { getOtherRefSearchDropdown } from "../api/keyvalue";
import DashboardInfoCard from "../components/DashboardInfoCard";
import Input from "../components/input/Input";
import SearchDropdown from "../components/input/SearchDropdown";
import LoadingSpinner from "../components/LoadingSpinner";
import { FORMS, MODULES } from "../const";
import useUserCompany from "../hooks/useUserCompany";
import { formatFromJsonDate } from "../dateConfig";
import Button from "../components/input/Button";
import SeasonalBanner from "../components/SeasonalBanner";
import TransporterDashboard from "./TransporterDashboard";
import FleetDashboard from "./fleet/FleetDashboard";
const ResponsiveGridLayout = WidthProvider(Responsive);

const TAB = { MAIN: "main", TRANSPORTER: "transporter", FLEET: "fleet" };

const Dashboard = () => {
  const userData = useSelector((state) => state.user.userDetails);
  const user = useSelector((state) => state.user);
  const auth = useSelector((state) => state.user.permissions[MODULES.Master]);
  const mainDashboardPermission =
    auth?.[FORMS?.MAIN_DASHBOARD?.DASHBOARD?.form] ?? {};
  const vehicleTypeChartPermission =
    mainDashboardPermission?.FORM?.VEHICLE_TYPE;
  const totalAssignmentsChartPermission =
    mainDashboardPermission?.FORM?.TOTAL_ASSIGNMENTS;
  const requestSummaryChartPermission =
    mainDashboardPermission?.FORM?.CURRENT_REQUEST_SUMMARY;
  const liveVehicleDataChartPermission =
    mainDashboardPermission?.FORM?.LIVE_VEHICLE_DATA;
  const placementAndBookingsChartPermission =
    mainDashboardPermission?.FORM?.PLACEMENT_ON_TIME_BOOKING;
  const transporterDashboardPermission = auth?.[FORMS.MAIN_DASHBOARD.TRANSPORTER_PANEL.form]?.FORM?.VIEW;
  const FleetDashboardPermission = auth?.[FORMS.MAIN_DASHBOARD.FLEET_MAIN_PANEL.form]?.FORM?.VIEW;

  const TABS = [
    { key: TAB.MAIN, label: "Main Dashboard" },
    ...(transporterDashboardPermission
      ? [{ key: TAB.TRANSPORTER, label: "Transporter Dashboard" }]
      : []),
    ...(FleetDashboardPermission
      ? [{ key: TAB.FLEET, label: "Fleet Dashboard" }]
      : []),
  ];

  console.log("mainDashboardPermission", mainDashboardPermission);

  const userCompany = useUserCompany();
  const [company, setCompany] = useState(
    userCompany ? userCompany.comId : null,
  );
  useEffect(() => {
    setCompany(userCompany ? userCompany.comId : null);
  }, [userCompany]);

  const chartStyle = { width: "100%", height: "400px" };

  const getFirstOfCurrentMonth = () => {
    const currentDate = new Date();
    const firstOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1,
    );
    return firstOfMonth.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };

  const [fromDate, setFromDate] = useState(getFirstOfCurrentMonth());
  // const [fromDate, setFromDate] = useState("2024-03-04");
  const [toDate, setToDate] = useState(new Date().toISOString().split("T")[0]);
  const [customer, setCustomer] = useState([]);
  const [transporter, setTransporter] = useState([]);
  const [shipper, setShipper] = useState([]);
  const [resetSearchFields, setResetSearchFields] = useState(false);
  console.log(
    "customer",
    customer,
    "transporter",
    transporter,
    "shipper",
    shipper,
  );

  const [showLastWeekRequests, setShowLastWeekRequests] = useState(true);
  const [showLastMonthRequests, setShowLastMonthRequests] = useState(true);
  const [showCompletedRequests, setShowCompletedRequests] = useState(true);
  const [showCurrentRequests, setShowCurrentRequests] = useState(true);
  const customerRef = useRef();
  const transporterRef = useRef();
  const shipperRef = useRef();

  const initialLayout = [];

  if (liveVehicleDataChartPermission) {
    initialLayout.push({ i: "live-vehicle-data", x: 1, y: 0, w: 1, h: 1 });
  }
  if (vehicleTypeChartPermission) {
    initialLayout.push({ i: "pie", x: 0, y: 0, w: 1, h: 1 });
  }
  if (totalAssignmentsChartPermission) {
    initialLayout.push({ i: "bar", x: 0, y: 1, w: 3, h: 1 });
  }
  if (requestSummaryChartPermission) {
    initialLayout.push({ i: "donut", x: 2, y: 0, w: 1, h: 1 });
  }
  // if (placementAndBookingsChartPermission) {
  //   initialLayout.push({ i: "placement", x: 0, y: 1, w: 3, h: 1 });
  // }

  const [livevehicleDateLoading, setLiveVehicleDataLoading] = useState(false);
  const [requestSummaryDataLoading, setRequestSummaryDataLoading] =
    useState(false);
  const [activeTab, setActiveTab] = useState("main");
  const [vehicleTypeDataLoading, setVehicleTypeDataLoading] = useState(false);
  const [shipperWiseJobsLoading, setShipperWiseJobsLoading] = useState(false);

  const [layout, setLayout] = useState(initialLayout);
  const [activeAccordion, setActiveAccordion] = useState(false);

  const onLayoutChange = (newLayout) => {
    setLayout(newLayout);
  };

  const pieChartOptions = {
    title: {
      text: "",
      left: "left",
    },
    tooltip: {
      trigger: "item",
      formatter: "{a} <br/>{b} : {c} ({d}%)",
    },
    // legend: {
    //   // top: "1%",
    //   left: "center",
    // },
    series: [
      {
        name: "Data",
        type: "pie",
        radius: "70%",
        center: ["50%", "50%"],
        data: localStorage.getItem("vehicleTypeData")
          ? JSON.parse(localStorage.getItem("vehicleTypeData")).map((item) => ({
              name: item.veh,
              value: item.reqCount,
            }))
          : [],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };

  const shipperData = localStorage.getItem("shipperWiseJobs")
    ? JSON.parse(localStorage.getItem("shipperWiseJobs"))
    : [];

  const barData = shipperData.map((item) => item.reqCount);
  const xLabels = shipperData.map((item) => item.stk);
  const yMin = 0;
  const yMax = Math.ceil(Math.max(...barData) / 10) * 10;

  const barChartOptions = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    grid: {
      left: "3%",
      right: "1%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        data: xLabels,
        axisTick: {
          alignWithLabel: true,
        },
        axisLabel: { interval: 0, rotate: 30 },
      },
    ],
    yAxis: [
      {
        type: "value",
        min: yMin,
        max: yMax,
      },
    ],
    series: [
      {
        name: "Requests",
        type: "bar",
        barWidth: "60%",
        data: barData,
        label: {
          show: true,
          position: "top",
          color: "#000",
          fontSize: 12,
        },
      },
    ],
  };

  const donutChartOptions = {
    title: {
      text: "",
      left: "left",
    },
    tooltip: {
      trigger: "item",
      formatter: "{a} <br/>{b} : {c} ({d}%)",
    },
    series: [
      {
        name: "Request Summary",
        type: "pie",
        radius: "70%",
        center: ["50%", "50%"],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
        data: localStorage.getItem("requestStatusSummaryData")
          ? JSON.parse(localStorage.getItem("requestStatusSummaryData")).map(
              (item) => ({
                value: item.reqCount,
                name: item.status,
                itemStyle: {
                  color: item.color,
                },
              }),
            )
          : [],
      },
    ],
  };

  const breakpoints = { lg: 1000, md: 960, sm: 720, xs: 480, xxs: 0 };
  const cols = { lg: 3, md: 2, sm: 2, xs: 1, xxs: 1 };

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width >= breakpoints.lg) {
        setLayout(initialLayout);
      } else if (width >= breakpoints.md) {
        setLayout(
          initialLayout.map((item) => ({ ...item, w: Math.min(item.w, 2) })),
        );
      } else if (width >= breakpoints.sm) {
        setLayout(
          initialLayout.map((item) => ({ ...item, w: Math.min(item.w, 1) })),
        );
      } else {
        setLayout(initialLayout.map((item) => ({ ...item, w: 1 })));
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const currentTime = new Date().getTime();

    if (
      !localStorage.getItem("lastExecutionTime") ||
      currentTime - localStorage.getItem("lastExecutionTime") >= 30000
    ) {
      // Execute your function if it's the first time or 30 seconds have passed
      fetchLiveRequestSummaryData();
      fetchRequestStatusSummaryData();
      fetchVehicleTypeData();
      // fetchTotalAssignments();
      // fetchPlacementAndBookings();
      fetchShipperWiseRequests();

      // Update the last execution time
      localStorage.setItem("lastExecutionTime", currentTime);
    }
  }, []);

  const fetchLiveRequestSummaryData = async () => {
    try {
      setLiveVehicleDataLoading(true);
      const data = {
        user: user.username,
        fromDate: fromDate,
        toDate: toDate,
        customer: customer?.join(","),
        transporter: transporter?.join(","),
        shipper: shipper?.join(","),
        company: company,
      };

      const liveRequestSummaryData = await getLiveRequestSummaryData(data);
      // setLiveRequestSummaryChartData(liveRequestSummaryData);
      console.log("live vehicle data", liveRequestSummaryData);
      if (liveRequestSummaryData.length > 0) {
        localStorage.setItem(
          "liveRequestSummaryData",
          JSON.stringify(liveRequestSummaryData),
        );
      } else {
        localStorage.setItem("liveRequestSummaryData", JSON.stringify([]));
      }
      setLiveVehicleDataLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const fetchRequestStatusSummaryData = async () => {
    try {
      setRequestSummaryDataLoading(true);
      const data = {
        user: user.username,
        fromDate: fromDate,
        toDate: toDate,
        customer: customer?.join(","),
        transporter: transporter?.join(","),
        shipper: shipper?.join(","),
        company: company,
      };

      const requestSummary = await getRequestStatusSummary(data);
      console.log("Request Summary", requestSummary);
      // setRequestSummaryChartData(requestSummary);
      if (requestSummary.length > 0) {
        localStorage.setItem(
          "requestStatusSummaryData",
          JSON.stringify(requestSummary),
        );
      } else {
        localStorage.setItem("requestStatusSummaryData", JSON.stringify([]));
      }
      setRequestSummaryDataLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const fetchVehicleTypeData = async () => {
    try {
      setVehicleTypeDataLoading(true);
      const data = {
        user: user.username,
        fromDate: fromDate,
        toDate: toDate,
        customer: customer?.join(","),
        transporter: transporter?.join(","),
        shipper: shipper?.join(","),
        company: company,
      };

      const vehicleTypeData = await getVehicleTypeData(data);
      // setVehicleTypeChartData(vehicleTypeData);
      console.log("vehicle type chart data in function", vehicleTypeData);

      if (vehicleTypeData.length > 0) {
        localStorage.setItem(
          "vehicleTypeData",
          JSON.stringify(vehicleTypeData),
        );
      } else {
        localStorage.setItem("vehicleTypeData", JSON.stringify([]));
      }

      setVehicleTypeDataLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const fetchShipperWiseRequests = async () => {
    try {
      setShipperWiseJobsLoading(true);

      const data = {
        user: user.username,
        fromDate: fromDate,
        toDate: toDate,
        customer: customer?.join(","),
        transporter: transporter?.join(","),
        shipper: shipper?.join(","),
        company: company,
      };

      const shipperWiseJobs = await getShipperWiseJobs(data);
      console.log("Shipper wise chart data in function", shipperWiseJobs);

      if (shipperWiseJobs.length > 0) {
        localStorage.setItem(
          "shipperWiseJobs",
          JSON.stringify(shipperWiseJobs),
        );
      } else {
        localStorage.setItem("shipperWiseJobs", JSON.stringify([]));
      }

      setShipperWiseJobsLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchLiveRequestSummaryData();
    fetchRequestStatusSummaryData();
    fetchVehicleTypeData();
    fetchShipperWiseRequests();
  }, [customer, transporter, shipper, fromDate, toDate, company, user]);

  useEffect(() => {
    if (
      fromDate !== getFirstOfCurrentMonth() ||
      toDate !== new Date().toISOString().split("T")[0]
    ) {
      setShowLastWeekRequests(false);
      setShowLastMonthRequests(false);
      setShowCompletedRequests(true);
      setShowCurrentRequests(false);
    } else {
      setShowLastWeekRequests(true);
      setShowLastMonthRequests(true);
      setShowCompletedRequests(true);
      setShowCurrentRequests(true);
    }
  }, [fromDate, toDate]);

  const handleReset = (e) => {
    e.preventDefault();
    setFromDate(getFirstOfCurrentMonth());
    setToDate(new Date().toISOString().split("T")[0]);
    setResetSearchFields(true);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ display: "flex", gap: "8px", marginBottom: "12px" }}>
        {TABS.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            style={{
              padding: "5px 16px",
              borderRadius: "20px",
              border: "none",
              cursor: "pointer",
              fontWeight: 500,
              fontSize: "13px",
              background:
                activeTab === tab.key
                  ? "#8d1212"
                  : "var(--color-background-secondary)",
              color: activeTab === tab.key ? "#E6F1FB" : "inherit",
              transition: "background 0.15s, color 0.15s",
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>
      {activeTab === TAB.TRANSPORTER && <TransporterDashboard />}
{activeTab === TAB.FLEET && <FleetDashboard />}
       {activeTab === TAB.MAIN && (
        <>
          {vehicleTypeChartPermission ||
          totalAssignmentsChartPermission ||
          requestSummaryChartPermission ||
          liveVehicleDataChartPermission ? (
            <div className="ui styled accordion" style={{ width: "100%" }}>
              <div
                className={`title ${activeAccordion ? "active" : ""}`}
                onClick={() => setActiveAccordion(!activeAccordion)}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label>Click here to filter</label>
                  <label>
                    <i className="dropdown icon" size={16}></i>
                  </label>
                </div>
              </div>
              <div className={`content ${activeAccordion ? "active" : ""}`}>
                <div className="ui form">
                  <div className="two fields">
                    <Input
                      type="date"
                      label="From Date"
                      placeholder="From Date"
                      value={fromDate}
                      max={toDate ? toDate : ""}
                      onChange={(e) => {
                        if (!e.target.value) return; // block clearing
                        if (e.target.value < toDate) {
                          setFromDate(e.target.value);
                        } else {
                          setFromDate(getFirstOfCurrentMonth());
                        }
                      }}
                    />
                    <Input
                      type="date"
                      label="To Date"
                      placeholder="To Date"
                      max={new Date().toISOString().split("T")[0]}
                      value={toDate}
                      onChange={(e) => {
                        if (!e.target.value) return; // block clearing
                        if (e.target.value > fromDate) {
                          setToDate(e.target.value);
                        } else {
                          setToDate(new Date().toISOString().split("T")[0]);
                        }
                      }}
                    />
                    <div
                      style={{
                        // width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        marginTop: "25px",
                      }}
                    >
                      <div className="field" style={{ width: "100%" }}>
                        <Button
                          template="searchReset"
                          onClick={(e) => {
                            handleReset(e);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="three fields"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    {userData.type === 1 ? (
                      <SearchDropdown
                        key={1}
                        editMode={false}
                        reset={resetSearchFields}
                        setReset={setResetSearchFields}
                        occupySpace={false}
                        multiple={true}
                        multiValueRemoveHandler={(key) => {
                          setCustomer((prev) =>
                            prev.filter((item) => item !== parseInt(key)),
                          );
                        }}
                        onResultSelect={(data) =>
                          setCustomer((prev) => [...prev, data])
                        }
                        api={getOtherRefSearchDropdown}
                        apiDependency={{
                          type: "stakeholder_type",
                          value: "Customer",
                        }}
                        label="Request Customer"
                      />
                    ) : (
                      <SearchDropdown
                        key={1}
                        editMode={false}
                        reset={resetSearchFields}
                        setReset={setResetSearchFields}
                        occupySpace={false}
                        multiple={true}
                        multiValueRemoveHandler={(key) => {
                          setCustomer((prev) =>
                            prev.filter((item) => item !== parseInt(key)),
                          );
                        }}
                        onResultSelect={(data) =>
                          setCustomer((prev) => [...prev, data])
                        }
                        api={getOtherRefSearchDropdown}
                        apiDependency={{
                          type: "user_stakeholder",
                          value: "Requesting Customer",
                          param2: user.username,
                        }}
                        label="Request Customer"
                      />
                    )}

                    <SearchDropdown
                      key={2}
                      editMode={false}
                      reset={resetSearchFields}
                      setReset={setResetSearchFields}
                      occupySpace={false}
                      multiple={true}
                      multiValueRemoveHandler={(key) => {
                        setShipper((prev) =>
                          prev.filter((item) => item !== parseInt(key)),
                        );
                      }}
                      onResultSelect={(data) =>
                        setShipper((prev) => [...prev, data])
                      }
                      api={getOtherRefSearchDropdown}
                      apiDependency={
                        userData.type === 1
                          ? {
                              type: "stakeholder_type",
                              value: "Shipper",
                              param2:
                                customer.length > 0 ? customer.join(",") : "",
                            }
                          : {
                              type: "user_stakeholder",
                              value: "Shipper",
                              param1:
                                customer.length > 0 ? customer.join(",") : "",
                              param2: user.username,
                            }
                      }
                      label="Shipper/Plant"
                      disabled={customer?.length === 0}
                    />
                    <SearchDropdown
                      key={2}
                      editMode={false}
                      reset={resetSearchFields}
                      setReset={setResetSearchFields}
                      occupySpace={false}
                      multiple={true}
                      multiValueRemoveHandler={(key) => {
                        setTransporter((prev) =>
                          prev.filter((item) => item !== parseInt(key)),
                        );
                      }}
                      onResultSelect={(data) =>
                        setTransporter((prev) => [...prev, data])
                      }
                      api={getOtherRefSearchDropdown}
                      apiDependency={
                        userData.type === 3
                          ? {
                              type: "user_stakeholder",
                              value: "Transporter",
                              param2: user.username,
                            }
                          : {
                              type: "stakeholder_type",
                              value: "Transporter",
                            }
                      }
                      label="Transporter"
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          <ResponsiveGridLayout
            className="layout"
            layouts={{
              lg: layout,
              md: layout,
              sm: layout,
              xs: layout,
              xxs: layout,
            }}
            breakpoints={breakpoints}
            cols={cols}
            onLayoutChange={onLayoutChange}
            isResizable={true}
            autoSize={true}
            rowHeight={460}
            margin={[10, 20]}
            useCSSTransforms={true}
            draggableCancel=".refresh-icon"
            resizeHandles={["se", "sw", "ne", "nw"]}
          >
            {layout.map((item) => (
              <div key={item.i} className="refresh-icon-container">
                {liveVehicleDataChartPermission &&
                  item.i === "live-vehicle-data" && (
                    <div
                      className="ui segment"
                      style={{
                        height: "100%",
                        overflowY: "auto",
                        boxShadow: " rgba(149, 157, 165, 0.2) 0px 8px 24px",
                      }}
                    >
                      {livevehicleDateLoading ? (
                        <LoadingSpinner height="100%" />
                      ) : (
                        <>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              position: "relative",
                            }}
                          >
                            <h3>Live Request Data Analysis</h3>
                            <RefreshCcw
                              size={16}
                              className="refresh-icon"
                              onClick={fetchLiveRequestSummaryData}
                            />
                          </div>
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "repeat(2, 1fr)", // exactly two columns
                              gap: "10px", // spacing between cards
                              margin: "auto",
                              justifyContent: "center",
                            }}
                          >
                            {localStorage.getItem("liveRequestSummaryData")
                              ? JSON.parse(
                                  localStorage.getItem(
                                    "liveRequestSummaryData",
                                  ),
                                ).map((item, index) =>
                                  (showLastMonthRequests &&
                                    item.title === "Last Month Requests") ||
                                  (showLastWeekRequests &&
                                    item.title === "Last Week Requests") ||
                                  (showCompletedRequests &&
                                    item.title === "Completed Requests") ||
                                  (showCurrentRequests &&
                                    item.title === "Current Requests") ? (
                                    <DashboardInfoCard
                                      key={index}
                                      label={item.title.replace(/_/g, " ")}
                                      value={item.reqCount}
                                    />
                                  ) : (
                                    ""
                                  ),
                                )
                              : []}
                          </div>
                        </>
                      )}
                    </div>
                  )}
                {vehicleTypeChartPermission && item.i === "pie" && (
                  <div
                    className="ui segment"
                    style={{
                      height: "100%",
                      boxShadow: " rgba(149, 157, 165, 0.2) 0px 8px 24px",
                    }}
                  >
                    {vehicleTypeDataLoading ? (
                      <LoadingSpinner height="100%" />
                    ) : (
                      <>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            position: "relative",
                          }}
                        >
                          <h3>Truck Type Wise Requests</h3>
                          <RefreshCcw
                            onClick={fetchVehicleTypeData}
                            size={16}
                            className="refresh-icon"
                          />
                        </div>
                        <ReactECharts
                          option={pieChartOptions}
                          style={chartStyle}
                        />
                      </>
                    )}
                  </div>
                )}
                {totalAssignmentsChartPermission && item.i === "bar" && (
                  <div
                    className="ui segment"
                    style={{
                      height: "100%",
                      boxShadow: " rgba(149, 157, 165, 0.2) 0px 8px 24px",
                    }}
                  >
                    {shipperWiseJobsLoading ? (
                      <LoadingSpinner height="100%" />
                    ) : (
                      <>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            position: "relative",
                          }}
                        >
                          <h3>Shipper Wise Requests</h3>
                          <RefreshCcw
                            size={16}
                            className="refresh-icon"
                            onClick={fetchShipperWiseRequests}
                          />
                        </div>
                        <ReactECharts
                          option={barChartOptions}
                          style={chartStyle}
                        />
                      </>
                    )}
                  </div>
                )}
                {requestSummaryChartPermission && item.i === "donut" && (
                  <div
                    className="ui segment"
                    style={{
                      height: "100%",
                      boxShadow: " rgba(149, 157, 165, 0.2) 0px 8px 24px",
                    }}
                  >
                    {requestSummaryDataLoading ? (
                      <LoadingSpinner height="100%" />
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          // justifyContent: "center",
                          flexDirection: "column",
                          // alignItems: "center",
                          // position: "relative",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            position: "relative",
                          }}
                        >
                          <h3>Current Request Summary</h3>
                          <RefreshCcw
                            size={16}
                            className="refresh-icon"
                            onClick={fetchRequestStatusSummaryData}
                          />
                        </div>
                        <ReactECharts
                          option={donutChartOptions}
                          style={chartStyle}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </ResponsiveGridLayout>
        </>
      )}
      <div></div>
    </div>
  );
};

export default Dashboard;
